"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var Transition_1 = tslib_1.__importDefault(require("react-transition-group/Transition"));
var Icon_1 = require("../../Icon");
var icons_1 = require("../../../icons");
var SubMenuLayer_1 = tslib_1.__importDefault(require("./SubMenuLayer"));
var base_1 = require("../../../themes/base");
var ModalCloseButton = styled_components_1.default(Icon_1.IconButton)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  right: 20px;\n  top: 24px;\n"], ["\n  position: absolute;\n  right: 20px;\n  top: 24px;\n"])));
var SubMenu = function (_a) {
    var isOpen = _a.isOpen, left = _a.left, right = _a.right, width = _a.width, height = _a.height, currentSize = _a.currentSize, onClose = _a.onClose, children = _a.children;
    var heightPerState = {
        entering: height,
        entered: height,
        exiting: 0,
        exited: 0,
        unmounted: 0
    };
    return (react_1.default.createElement(Transition_1.default, { in: isOpen, timeout: base_1.base.global.transition.durationMS }, function (state) { return (react_1.default.createElement(SubMenuLayer_1.default, { currentSize: currentSize, left: left, right: right, height: heightPerState[state], width: width },
        react_1.default.createElement(ModalCloseButton, { label: "close", onClick: onClose, "data-testid": "close-btn", iconProps: {
                id: 'close',
                icon: icons_1.Clear,
                width: '12px',
                height: '12px'
            } }),
        children)); }));
};
exports.default = SubMenu;
var templateObject_1;
//# sourceMappingURL=SubMenu.js.map